import FormModal from "../../common/formModal"
import DataTable from "../../components/DataTable";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ReactComponent as Search } from "../../assets/icons/main/search-icon.svg";
import { ReactComponent as DataSuccessIcon } from '../../assets/icons/database-check-icon.svg';
import { ReactComponent as DataFailIcon } from '../../assets/icons/database-remove-icon.svg';
import { ReactComponent as ExpandIcon } from '../../assets/icons/main/expand-icon.svg';
import { ReactComponent as CollapseIcon } from '../../assets/icons/main/collapse-icon.svg';
import { ReactComponent as DatabaseConnectivityIcon } from '../../assets/icons/databaseConnectivityIcon.svg';
import { ReactComponent as ConnectivityIcon } from '../../assets/icons/connectivityIcon.svg';

import { ReactComponent as VrLine } from '../../assets/icons/main/verticalLine.svg';
import { Box, Button, Card, CardContent, Dialog, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { JsonView, allExpanded, collapseAllNested, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import './connectivity.css';
import { ReactComponent as ArrowDownOutlinedIcon } from '../../assets/ArrowDownOutlinedIcon.svg';
import { ReactComponent as ArrowUpOutlinedIcon } from '../../assets/ArrowUpOutlinedIcon.svg';
import Modal from "../../common/Modal";
import CloseIcon from '@mui/icons-material/Close';
import { palette } from '../../theme/palette';
import Styles from '../../theme/commonCss/Styles';

const styles = {
    input: {
        width: "300px",
        borderRadius: "8px",
        height: "42px",
        marginBottom: "24px",
        border: "none",
        opacity: 0.4
    },
    button: {
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal',
        color: '#5C85FF',
        textTransform: 'capitalize'
    }, dialog: {
        muiPaper: {
            maxWidth: '800px',
            padding: '21px 32px 32px',
            width: '800px',
            borderRadius: '18px',
            backgroundColor: `${palette.transparent.main}`,
        },
        // '& .MuiPaper-root:not(.MuiAccordion-root)': {
        // maxWidth: '800px',
        // padding: '21px 32px',
        // width: '800px',
        // borderRadius: '18px',
        //   backgroundColor: `${palette.transparent.main}`,
        // },
        // '&.MuiPaper-root.MuiDialog-root': {
        //   maxWidth: '800px',
        //   padding: '21px 32px',
        //   width: '800px',
        //   borderRadius: '18px',
        //   backgroundColor: `${palette.transparent.main}`,
        // },
    },
    dialogTitle: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '1.3rem',
        color: `${palette.disabled.dark}`,
        padding: '0px 0px 21px 0px',
        fontFamily: 'Open Sans',
        fontWeight: '400',
    },
    content: {
        '&.MuiDialogContent-root': {
            padding: '0px',
            backgroundColor: `${palette.transparent.main}`,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItem: 'center',
            borderRadius: '18px',
        },
    },
    closeIcon: {
        cursor: 'pointer',
    },
}


export const AssetList = (props: any) => {
    const [searchString, setSearchString] = useState<any>('')
    const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
    const [assetsData, setAssetsData] = useState<any>([])

    const columns: any = [
        {
            field: 'asset_id',
            headerName: 'ASSET NAME',
            resizable: false,
            headerAlign: 'left',
            align: 'left',
            flex: 1,
            minWidth: 100,
        },
        {
            field: 'latest_message',
            headerName: 'MESSAGE',
            resizable: false,
            headerAlign: 'left',
            align: 'left',
            flex: 1,
            minWidth: 100,
            renderCell: (params: any) => {
                return (<Box sx={{ height: '60px', overflow: 'scroll', display: 'flex', alignItems: 'center' }}><JsonView data={params?.row?.latest_message} shouldExpandNode={()=>false}  style={defaultStyles} /></Box>)

                // return (<>{JSON.stringify(params?.row?.latest_message)}</>)
            }
        },
    ]
    const handleChange = (e: any) => {
        setSearchString(e.target.value)
    }



    const handleAccordion = (item: any, status: any) => {
        setAssetsData(assetsData.map((i: any, index: any) => {
            if (item.id == i.id) {
                return { ...item, expanded: status, id: (index + 1) }
            } else {
                return { ...i, expanded: false, id: (index + 1) }
            }

        }))
    };

    useEffect(() => {
        const data = props.data.assets;
        setAssetsData(data.map((items: any, index: any) => {
            return { ...items, expanded: false, id: (index + 1) }
        }))
    }, [props])

    return (
        <Modal
            title={props.title.toUpperCase()}
            open={props.isOpen}
            handleClose={props.handleClose}
            dialogContentStyles={Styles.masterContainer}
            customStyles={{
                maxHeight: '80vh'
            }}
        >
            <Card sx={{ ...Styles.card, padding: '0px' }}>
                <CardContent component='form' sx={{ ...Styles.cardContent }}>
                    <Box>
                        <Box display={'flex'} justifyContent={'end'} padding={'24px 24px 0px 24px'}>
                            {(assetsData.length > 0) ? <TextField
                                placeholder="Search"
                                variant="outlined"
                                color="secondary"
                                // startAdornment={<img src={search}></img>}
                                onChange={handleChange}
                                sx={{ ...styles.input, '& .MuiOutlinedInput-root': { backgroundColor: 'white', padding: '9px 16px', fontSize: '1rem' } }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            <Search />
                                        </InputAdornment>
                                    ),
                                }}
                            /> : ''}
                        </Box>
                        <Box sx={{ overflowX: 'none', overflow: 'auto', height: '300px' }}>
                            {(assetsData.length > 0) ? assetsData.filter((item: any) => {
                                return item?.asset_id.toLowerCase().includes(searchString.toLowerCase()) || item?.connectivity_status.toLowerCase().includes(searchString.toLowerCase())
                            }).map((item: any, index: any) => (
                                <Accordion sx={{
                                    // pointerEvents: "none",
                                    boxShadow: 'none',
                                    borderRadius: '0px',
                                    borderLeft: '1px solid  #D9DFED80',
                                    borderRight: '1px solid  #D9DFED80',
                                    borderTop: ((index % 2) == 0) ? '1px solid  #D9DFED80' : '',
                                    borderBottom: (index === (assetsData.length - 1)) ? '1px solid  #D9DFED80' : '',
                                    background: ((index % 2) != 0) ? '#FFF' : '#F8FAFB80',

                                    '.MuiButtonBase-root.MuiAccordionSummary-root':{
                                        cursor: "default !important",
                                    },
                                    '.MuiPaper-root-MuiAccordion-root:last-of-type': {
                                        borderRadius: '0px',
                                    },
                                    '&.MuiPaper-root.MuiAccordion-root.Mui-expanded': {
                                        margin: '0px !important'
                                    }
                                }} expanded={item.expanded}>
                                    {/* // onChange={() => handleAccordion(item)}> */}
                                    <AccordionSummary
                                        // expandIcon={<Button>View Details</Button>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"

                                        sx={{
                                            cursor:'default',
                                            minHeight: '42px',
                                            height: '42px',
                                            padding: '10px 10px 10px 24px',
                                            '& .MuiAccordionSummary-content': {
                                                margin: '0px',
                                                // pointerEvents: 'none'
                                            },
                                            '& .Mui-expanded': {
                                                margin: 0,
                                            },
                                            '& .MuiAccordionSummary-contentGutters': {
                                                margin: 0,
                                            },
                                            '&.MuiAccordionSummary-root.Mui-expanded': {
                                                minHeight: '42px !important',
                                                borderBottom: '1px solid  #D9DFED80',
                                                borderTop: '1px solid  #D9DFED80'
                                            }
                                        }}
                                    >
                                        <Grid container alignItems={'center'}>
                                            <Grid xs={8}>
                                                <Typography sx={{
                                                    color: '#64759F',
                                                    fontFamily: 'Open Sans',
                                                    fontSize: '1rem',
                                                    fontStyle: 'normal',
                                                    fontWeight: '400',
                                                    lineHeight: 'normal',
                                                    textTransform: 'uppercase'
                                                }}>{item.asset_id}</Typography>
                                            </Grid>
                                            <Grid xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    {(item.connectivity_status === 'connected') ? <Fragment>
                                                        <div>
                                                            <ConnectivityIcon style={{color:'#0EAB4E'}} />
                                                        </div>
                                                        <div style={{ paddingLeft: '12px' }}>
                                                            {(item.latest_message?.payload?.message_type === "data_error") ? <DatabaseConnectivityIcon style={{color:'#D81010'}} /> : <DatabaseConnectivityIcon style={{color:'#0EAB4E'}} />}
                                                        </div>
                                                    </Fragment> : <Fragment>
                                                        <div>
                                                            <ConnectivityIcon style={{color:'#D81010'}} />
                                                        </div>
                                                        <div style={{ paddingLeft: '12px' }}>
                                                            <DatabaseConnectivityIcon style={{ color:'#BDC1CB'}} />
                                                        </div>
                                                    </Fragment>}
                                                </Box>
                                                <VrLine style={{ height: '22px', marginLeft: '12px' }} />
                                                {item.expanded ? <IconButton onClick={() => handleAccordion(item, false)}> <CollapseIcon style={{transform:'rotate(90deg)'}}/> </IconButton> : <IconButton onClick={() => handleAccordion(item, true)}> <ExpandIcon style={{transform:'rotate(90deg)'}}/> </IconButton> }
                                            </Grid>
                                        </Grid>

                                    </AccordionSummary>
                                    <AccordionDetails sx={{
                                        backgroundColor: 'white', borderRadius: '0px', padding: '12px 24px 0px 24px'
                                    }}>
                                        <Typography sx={{fontSize:'1rem', marginLeft:'12px', color:'#434D67', marginBottom:'10px', fontWeight:'600', fontStyle:'normal'}}>Message</Typography>
                                        <Box sx={{ height: 'auto', overflow: 'scroll', display: 'flex', alignItems: 'center' }}><JsonView data={item?.latest_message} shouldExpandNode={() =>false} style={defaultStyles} /></Box>
                                    </AccordionDetails>
                                </Accordion >)) : <div style={{ display: 'flex', justifyItems: 'center', marginTop: '10%', flexDirection: 'column', alignItems: 'center' }}>Assets not found.</div>}

                        </Box>
                    </Box>
                    <Grid container sx={{ marginTop: '24px' }}>
                        <Grid xs={12} textAlign={'center'} sx={{ paddingBottom: '24px' }}>
                            <Button variant='outlined' sx={{ mr: 3, width: '100px', height: '42px' }} onClick={props.handleClose}>
                                Close
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Modal>
    )
}

